import React from "react";
import { useSelector } from "react-redux";
import { getCustomFeedback } from "src/features/order/selectors/restaurantFlags";
import { Button, Text } from "src/sharedComponents";
import { href } from "src/common/experience";

export const PayOnlyCustomFeedback = () => {
    const { url, buttonText } = useSelector(getCustomFeedback);

    if (!url) return null;

    return (
        <div className="pay-only-receipt__venue-feedback">
            <Button mode="outline" unthemed>
                <a {...href.openInNewWindowAttributes(url)}>
                    <Text preset="g-16" mode="bold">
                        {buttonText || "Give venue feedback"}
                    </Text>
                </a>
            </Button>
        </div>
    );
};
